module.exports = __webpack_public_path__ + "img/dataPoster_logo.b9320de1.png";